module.exports = __webpack_public_path__ + "img/1-1.6f1325f2.png";